import React, {
  ReactElement,
  useEffect,
  useState,
  useRef, useCallback, useMemo,
} from 'react';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Box from '@mui/material/Box';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import Paper, {PaperProps} from "@mui/material/Paper";
import Draggable from "react-draggable";
import {v4 as uuidv4} from "uuid";
import { DragIndicatorRounded, ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material";
import {ServiceReservationTable} from "./ServiceReservationTable";
import {AccommodationReservationTable} from "./AccommodationReservationTable";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ReservationDialog = ({
  handleClose,
  row,
}: {
  handleClose: () => void;
  row: any;
}): ReactElement => {

  const [isAccommodationOpen, setIsAccommodationOpen] = useState(true);
  const accommodationPanelRef = useRef<any>(null);

  const draggablePaneId = useMemo(() => {
    return `draggable-responsive-add-new-dialog-${uuidv4()}`;
  }, []);

  const toggleAccommodationPanel = useCallback(() => {
    if (!accommodationPanelRef.current) return;

    if (isAccommodationOpen) {
      accommodationPanelRef.current.collapse();
      setIsAccommodationOpen(false);
    } else {
      accommodationPanelRef.current.expand();
      setIsAccommodationOpen(true);
    }
  }, [isAccommodationOpen]);

  const PaperComponent = useCallback(
    (props: PaperProps) => {
      return (
        <Draggable
          handle={`#${draggablePaneId}, .drag-handle`}
          cancel={'[class*="MuiDialogContent-root"], .non-draggable-button'}
        >
          <Paper {...props} />
        </Draggable>
      );
    },
    []
  );

  return (
    <>

      <Dialog
        PaperComponent={PaperComponent}
        fullScreen
        open={true}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{
          '& .MuiPaper-root.MuiDialog-paper': {
            maxWidth: 'calc(100% - 180px)',
            height: 'calc(100% - 100px)',
          },
        }}
      >
        <AppBar
          sx={{
            position: 'relative',
            background: '#256861',
          }}
        >
          <Toolbar
            id={draggablePaneId}
          >
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {`${row?.name} - Reservations`}
            </Typography>
            {/* <Button autoFocus color="inherit" onClick={handleClose}>
              save
            </Button>*/}
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            p: '0px',
            height: '100%',
            position: 'relative',
          }}
        >
          <PanelGroup direction="vertical">
            <Panel defaultSize={67} minSize={20}>
              <ServiceReservationTable
                handleClose={() => {}}
                row={row}
              />
            </Panel>

            <PanelResizeHandle
              style={{
                height: '8px',
                background: '#e0e0e0',
                cursor: 'row-resize',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                }}
              >
                <IconButton
                  size="small"
                  onClick={toggleAccommodationPanel}
                  sx={{
                    background: '#fff',
                    border: '1px solid #ddd',
                    zIndex: 2,
                  }}
                >
                  {isAccommodationOpen ? (
                    <ExpandMoreRounded fontSize="small" />
                  ) : (
                    <ExpandLessRounded fontSize="small" />
                  )}
                </IconButton>
              </Box>
            </PanelResizeHandle>

            <Panel
              ref={accommodationPanelRef}
              defaultSize={33}
              minSize={0}
              collapsible
              collapsedSize={0}
              onCollapse={() => setIsAccommodationOpen(false)}
              onExpand={() => setIsAccommodationOpen(true)}
            >
              <AccommodationReservationTable
                handleClose={() => {}}
                row={row}
              />
            </Panel>
          </PanelGroup>
        </Box>

        <IconButton
          sx={{
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '20px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '0px',
            position: 'absolute',
            bottom: 0,
            left: 0,
            background: '#0000000a'
          }}
          className="drag-handle" size="small" aria-label="Drag dialog">
          <DragIndicatorRounded fontSize={'small'} />
        </IconButton>

        <IconButton
          sx={{
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
            borderBottomLeftRadius: '0px',
            position: 'absolute',
            bottom: 0,
            right: 0,
            background: '#0000000a'
          }}
          className="drag-handle" size="small" aria-label="Drag dialog">
          <DragIndicatorRounded fontSize={'small'} />
        </IconButton>

      </Dialog>
    </>
  );
};
